import c from 'classnames';
import React from 'react';

import { GaugeChart, Typography } from '@repo/ui';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import useKitSummaryScores from 'services/kits/useKitSummaryScores';
import styles from './ProMss.module.css';
import slideStyles from './Slides.module.css';
import { PRO_MSS_MESSAGES } from './constants';

// Module-level on purpose: GaugeChart rebuilds its Chart whenever this object's
// identity changes, so an inline literal would recreate it on every render.
const GAUGE_EXTRA_OPTIONS = {
  circleBorder: false,
  useNewArrow: true,
  animation: {
    duration: 1000,
    delay: 100,
    arrowEndOffset: -300,
  },
};

export const ProMss: React.FC = () => {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const { data, isLoading } = useKitSummaryScores(
    currentKit?.id ?? '',
    'pro_mss',
  );
  const summaryData = data ? data[0] : null;

  if (isLoading || !summaryData) return <></>;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.mss }}
    >
      <div className={styles.container}>
        <Typography variant='eyebrow' className={styles.header}>
          Your PRO score
        </Typography>
        <GaugeChart
          color={summaryData.evaluation_color}
          label={summaryData.evaluation_text}
          labelVariant='display-s'
          width={327}
          height={150}
          overrideColors={{
            grey: '#007C6C',
          }}
          overrideTextColors={{
            red: '#8C3C3C',
            orange: '#CC7700',
            grey: '#007C6C',
          }}
          extraOptions={GAUGE_EXTRA_OPTIONS}
        />
        <Typography variant='body-s' className={styles.description}>
          {PRO_MSS_MESSAGES[summaryData.evaluation_color]}
        </Typography>
      </div>
    </div>
  );
};
